// shelbulaworkspaces/ConfirmFileDeleteModal.jsx
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';

const ConfirmFileDeleteModal = ({ isOpen, onClose, onConfirm, fileNode }) => {
    const [isConfirmed, setIsConfirmed] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setIsConfirmed(false);
        }
    }, [isOpen]);

    if (!fileNode) return null;

    const handleConfirm = () => {
        if (isConfirmed) {
            onConfirm(fileNode);
        }
    };
    
    return ReactDOM.createPortal(
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        className="relative w-full max-w-md bg-surface rounded-xl border border-border-color shadow-xl"
                    >
                         <div className="flex justify-between items-center p-4 border-b border-border-color">
                            <h2 className="text-lg font-bold text-on-surface flex items-center gap-2">
                                <AlertTriangle size={20} className="text-error" />
                                Confirm Deletion
                            </h2>
                            <button onClick={onClose} className="p-1 rounded-full text-on-surface-dim hover:bg-surface-dark hover:text-on-surface transition-colors">
                                <X size={20} />
                            </button>
                         </div>

                         <div className="p-4">
                            <p className="text-sm text-on-surface-dim">This action is permanent and cannot be undone. The following file or folder will be deleted:</p>
                            <p className="text-sm text-on-surface font-mono bg-background p-3 rounded-md my-3">{fileNode.path}</p>
                            
                            <label className="flex items-center gap-2.5 cursor-pointer select-none">
                                <input
                                    type="checkbox"
                                    checked={isConfirmed}
                                    onChange={(e) => setIsConfirmed(e.target.checked)}
                                    className="h-4 w-4 rounded border-border-color bg-surface-dark text-error focus:ring-error focus:ring-1"
                                />
                                <span className="text-sm text-on-surface-dim">I understand and wish to proceed.</span>
                            </label>
                        </div>

                         <div className="flex justify-end gap-3 p-4 border-t border-border-color">
                            <button onClick={onClose} className="px-4 py-2 text-sm font-semibold rounded-md text-on-surface bg-surface-dark hover:bg-surface-raised transition-colors">
                                Cancel
                            </button>
                            <button 
                                onClick={handleConfirm}
                                disabled={!isConfirmed}
                                className="px-4 py-2 text-sm font-semibold rounded-md bg-error text-white disabled:bg-surface-dark disabled:text-text-disabled disabled:cursor-not-allowed hover:brightness-110 transition-all"
                            >
                                Confirm & Delete
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>,
        document.body
    );
};

export default ConfirmFileDeleteModal;